import { defineMessages, IntlShape } from "react-intl";

import CountryCode from "@mapmycustomers/shared/enum/CountryCode";

const messages = defineMessages<string>({
  [CountryCode["CANADA"]]: {
    id: "countryDataSource.ca",
    defaultMessage: "CA Census",
    description: "CA Census",
  },
  [CountryCode["UNITED STATES OF AMERICA"]]: {
    id: "countryDataSource.us",
    defaultMessage: "Decennial US Census",
    description: "Decennial US Census",
  },
});

const getDataSourceDisplayName = (intl: IntlShape, countryCode: CountryCode) =>
  intl.formatMessage(messages[countryCode]);

export default getDataSourceDisplayName;
